import React, { useEffect, useContext } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ReactDOM from 'react-dom'
import ModalWindow from '../../layout/modalwindow/ModalWindow'
import { ContentInner } from '../../layout/Content'
import CloseButton from '../../layout/close_button/CloseButton'
import { ManageInvoicesStyle, PaymentHistoryStyle, SOAStyle, CustomerCreditAccountInnerStyle } from './css/CustomerCreditAccountInnerStyle'
import AddInvoiceForm from './form/AddInvoiceForm'
import InvoiceItemController from '../../invoice/invoiceitem/InvoiceItemController'
import ReceiptItemController from '../../receipt/receiptitem/ReceiptItemController'
import PrinterSettingsStyle from '../../../css/PrinterSettingsStyle'
import { customerCreditAccountControllerContext } from './CustomerCreditAccountController'
import { formatNumber } from '../../utilities/utilities'
import { appContext } from '../../../App'
import { getInvoiceById } from '../CustomersAccountsFunctions'

function CustomerCreditAccountInner() {
  const app = useContext(appContext)
  const setContent = app.content[1]
  const customerCreditAccountController = useContext(customerCreditAccountControllerContext)
  const { addInvoices, removeInvoice, creditAccount, customerAccount, receiptsList } = customerCreditAccountController
  const [tabContent, setTabContent] = customerCreditAccountController.tabContent

  let paymentGrandTotal = 0
  let cashPaymentTotal = 0
  let chequesPaymentTotal = 0
  if (receiptsList) {
    receiptsList.forEach(receipt => {
      const cashPayment = receipt.payments.find(payment => payment.name === 'Cash')
      const chequesPayment = receipt.payments.find(payment => payment.name === 'Cheques')
      paymentGrandTotal += receipt.payments[0].total_amount_paid
      cashPaymentTotal += (cashPayment ? cashPayment.total : 0.00)
      chequesPaymentTotal += (chequesPayment ? chequesPayment.total : 0.00)
    })
  }

  const addInvoiceFormProps = {
    customerAccount,
    creditAccount,
    addInvoices,
    app
  }

  function ManageInvoices({ show }) {
    if (creditAccount) {
      if (creditAccount.status === 'Settled') show = false
    }
    return (
      <React.Fragment>
        <div className='customer-credit-account-table-container' style={{display: (show) ? 'block' : 'none'}}>
          <table className='customer-credit-account-table striped-table'>
            <thead>
              <tr>
                <th style={{textAlign: 'left'}}>Date Added</th>
                <th style={{textAlign: 'left'}}>Invoice Date</th>
                <th>Invoice Number</th>
                <th style={{textAlign: 'left'}}>Sold To</th>
                <th style={{textAlign: 'right'}}>Invoice Amount</th>
                <th>Actions</th>
              </tr>
            </thead>
            {
              (creditAccount) ?
              creditAccount.invoices.map(invoice => (
                <tbody className='invoice-body' id={invoice.invoice_number} key={invoice.invoice_number}>
                  <tr>
                    <td>
                      <div>{new Date(invoice.date_added).toLocaleString("en-us", { timeZone: invoice.client_timezone })}</div>
                      <div>{invoice.client_timezone}</div>
                    </td>
                    <td>{new Date(invoice.invoice_date).toLocaleString("en-us", { timeZone: invoice.invoice_client_timezone }).split(",")[0]} {invoice.invoice_client_timezone}</td>
                    <td style={{textAlign: 'center'}}>
                      <button
                        onClick={onClickInvoiceItem}
                        className='linked-button'>
                        {invoice.invoice_number.toUpperCase()}
                      </button>
                    </td>
                    <td>{invoice.sold_to}</td>
                    <td style={{textAlign: 'right'}}>P{formatNumber(invoice.invoice_summary.total_sales)}</td>
                    <td style={{textAlign: 'center'}}>
                      <CloseButton onClick={onClickDeleteInvoice} title='remove invoice from list'/>
                    </td>
                  </tr>
                </tbody>
              ))
              : null 
            }
            <tbody>
              <tr>
                <td colSpan='4'></td>
                <td style={{textAlign: 'right'}}>
                  <b>Total: <span style={{color: 'red'}}>P{(creditAccount) ? formatNumber(creditAccount.total_amount) : 0.00}</span></b>
                </td>
              </tr>
            </tbody>
            <tbody>
              <tr>
                <td colSpan='5'></td>
                <td style={{textAlign: 'center'}}>
                  <button
                    title='Add invoice'
                    className='pospro-action-btn'
                    onClick={onClickAddInvoice}>
                    <FontAwesomeIcon icon='plus'/>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <ManageInvoicesStyle />
      </React.Fragment>
    )
  }

  function PaymentHistory({ show }) {
    return (
      <React.Fragment>
        <div className={(show) ? 'payment-history-table-container printable black-and-white' : ''} style={{display: (show) ? 'block' : 'none'}}>
          <div className='payment-history-table-header'>
            <div style={{textAlign: 'center', fontWeight: 'bold'}}>Payment History</div>
            <div>As of {`${new Date(app.getClientDateTime()).toLocaleString("en-us")} ${app.getClientTimezone()}`}</div>
            <div><b>Customer Account Name:</b> {(customerAccount) ? customerAccount.customer_details.account_name : null}</div>
            <div><b>Customer Account Number:</b> {(customerAccount) ? customerAccount._id.toUpperCase() : null}</div>
            <div><b>Credit Account Number:</b> {(creditAccount) ? creditAccount.credit_account_number : null}</div>
          </div>
          <table className='payment-history-table'>
            <thead>
              <tr>
                <th className='empty-header' style={{textAlign: 'left'}}>Receipt Date</th>
                <th className='empty-header' style={{textAlign: 'left'}}>Receipt Number</th>
                <th className='empty-header' style={{textAlign: 'left'}}>Paid By</th>
                <th className='empty-header' style={{textAlign: 'right'}}>Amount</th>
              </tr>
            </thead>
            {
              (receiptsList) ?
                receiptsList.map(receipt => (
                  <tbody key={receipt._id}> 
                    <tr>
                      <td style={{textAlign: 'left'}}>{`${new Date(receipt.receipt_date).toLocaleString("en-us", { timeZone: receipt.client_timezone }).split(",")[0]} ${receipt.client_timezone}`}</td>
                      <td style={{textAlign: 'left'}}>
                        <button
                          onClick={(e) => { setContent(<ReceiptItemController receipt={receipt} />) }}
                          className='linked-button font-courier'>
                          {receipt._id.toUpperCase()}
                        </button>
                      </td>
                      <td style={{textAlign: 'left'}}>{receipt.paid_by}</td>
                      <td style={{textAlign: 'right'}}>P{formatNumber(receipt.payments[0].total_amount_paid)}</td>
                    </tr>
                  </tbody>
                ))
              : null
            }
            <tbody>
              <tr>
                <td style={{textAlign: 'left'}}></td>
                <td style={{textAlign: 'left'}}></td>
                <td style={{textAlign: 'left', fontWeight: 'bold'}}></td>
                <td style={{textAlign: 'right', fontWeight: 'bold'}}>
                  <b>Total: <span style={{color: 'blue'}}>P{formatNumber(paymentGrandTotal)}</span></b>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <PaymentHistoryStyle />
        { (show) ? <PrinterSettingsStyle paperWidth='8.5inch'/> : null }
      </React.Fragment>
    )
  }

  function SOA({ show }) {
    //const today = new Date()
    return (
      <React.Fragment>
        <div style={{display: (show) ? 'block' : 'none'}}>
          {
            (customerAccount) ?
              <div className={(show) ? 'statement-of-account-table-container printable' : ''}>
                <div className='statement-of-account-header-container'>
                  <div style={{textAlign: 'center', fontWeight: 'bold'}}>Statement Of Account</div>
                  <br/>
                  <div className='statement-of-account-header-title'>
                    {customerAccount.customer_details.account_name}, Statement Of Account as of {`${new Date(app.getClientDateTime()).toLocaleString("en-us")} ${app.getClientTimezone()}`}
                  </div>
                  <div className='statement-of-account-number-container'>
                    <b>Credit Account Number:</b> {(creditAccount) ? creditAccount.credit_account_number : null}
                  </div>
                </div>
                <table className='statement-of-account-table'>
                  <thead>
                    <tr>
                      <th style={{textAlign: 'left'}}>Invoice Number</th>
                      <th style={{textAlign: 'left'}}>Sold To</th>
                      <th style={{textAlign: 'left'}}>Date Time Added</th>
                      <th style={{textAlign: 'left'}}>Invoice Date</th>
                      <th style={{textAlign: 'right'}}>Invoice Amount</th>
                    </tr>
                  </thead>
                  {
                    (creditAccount) ?
                      creditAccount.invoices.map(invoice => (
                        <tbody key={invoice.invoice_number}>
                          <tr>
                            <td>{invoice.invoice_number.toUpperCase()}</td>
                            <td>{invoice.sold_to}</td>
                            <td>{new Date(invoice.date_added).toLocaleString("en-us", { timeZone: invoice.client_timezone })} { invoice.client_timezone }</td>
                            <td>{new Date(invoice.invoice_date).toLocaleString("en-us", { timeZone: invoice.client_timezone }).split(",")[0]} { invoice.client_timezone }</td>
                            <td style={{textAlign: 'right'}}>P{formatNumber(invoice.invoice_summary.total_sales)}</td>
                          </tr>
                        </tbody>
                      ))
                    : null
                  }

                  <tbody className='amount-due-grand-total'>
                    <tr>
                      <td colSpan='3'></td>
                      <td style={{textAlign: 'left'}}>Grand Total</td>
                      <td style={{textAlign: 'right'}}>P{(creditAccount) ? formatNumber(creditAccount.total_amount) : 0.00}</td>
                    </tr>
                  </tbody>

                  <tbody className='payment-details-header'>
                    <tr>
                      <td colSpan='3'></td>
                      <td colSpan='2'>Statement Of Account Payment Details</td>
                    </tr>
                  </tbody>
                  {
                    (cashPaymentTotal) ?
                      <tbody className='payments-total'>
                        <tr>
                          <td colSpan='3'></td>
                          <td style={{textAlign: 'left'}}>Total Cash Paid</td>
                          <td style={{textAlign: 'right'}}>P{formatNumber(cashPaymentTotal)}</td>
                        </tr>
                      </tbody>
                    : null
                  }

                  {
                    (chequesPaymentTotal) ?
                      <tbody className='payments-total'>
                        <tr>
                          <td colSpan='3'></td>
                          <td style={{textAlign: 'left'}}>Total Cheques Paid</td>
                          <td style={{textAlign: 'right'}}>P{formatNumber(chequesPaymentTotal)}</td>
                        </tr>
                      </tbody>
                    : null
                  }
                  <tbody className='payments-total'>
                    <tr>
                      <td colSpan='3'></td>
                      <td style={{textAlign: 'left'}}>Total Amount Paid</td>
                      <td style={{textAlign: 'right'}}>P{formatNumber(paymentGrandTotal)}</td>
                    </tr>
                  </tbody>
                  <tbody style={{fontWeight: 'bold'}} className='paments-total'>
                    <tr>
                      <td colSpan='3'></td>
                      <td style={{textAlign: 'left'}}>Balance</td>
                      <td style={{textAlign: 'right'}}>P{((creditAccount) ? formatNumber(creditAccount.total_balance) : 0.00)}</td>
                    </tr>
                  </tbody>
                </table >
              </div>
            : null
          }
        </div>
        <SOAStyle />
        { (show) ? <PrinterSettingsStyle paperWidth='8.5inch'/> : null }
      </React.Fragment>
    )
  }

  const onClickAddInvoice = () => {
    ReactDOM.render(
      <ModalWindow
        id='mw-parent'
        header='Add Invoice'
        height='70'
        width='45'
        footer={null}>
        <AddInvoiceForm { ...addInvoiceFormProps }/>
      </ModalWindow>,
      document.getElementById('modal-form-container')
    )
  }

  const onClickDeleteInvoice = async (e) => {
    const deleteInvoiceButton = e.target.closest('.invoice-body')
    await removeInvoice(deleteInvoiceButton.id)
  }

  const onClickInvoiceItem = async (e) => {
    const invoice = await getInvoiceById(app, e.target.innerText)
    //setContent(<InvoiceItemController invoiceItem={invoiceItem}/>)
    setContent(<InvoiceItemController invoice={invoice}/>)
  }

  const onClick = (e) => {
    document
    .querySelectorAll('.tab-button')
    .forEach(tab => {
      tab.classList.remove('tab-button-active')
    })

    document
    .getElementById(e.target.id)
    .classList
    .add('tab-button-active')

    setTabContent(parseInt(e.target.id))
  }

  useEffect(() => {
    if (creditAccount) {
      if (creditAccount.status === 'Settled') {
        document
        .getElementById('1payment-history-tab-button')
        .classList
        .add('tab-button-active')
        setTabContent(1)
      }
    }
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [creditAccount])

  return (
    <ContentInner>
      <div className='customer-credit-account-container'>
        <div className='credit-account-title'>
        {
          (creditAccount)
          ? <div>
              <div><b>Credit Account Number:</b> { creditAccount.credit_account_number }</div>
              <div><b>Date & Time Created:</b> {`${new Date(creditAccount.date_time_created).toLocaleString("en-us", { timeZone: creditAccount.client_timezone })} ${creditAccount.client_timezone}`}</div>
              <div><b>Balance:</b> <span style={{color: 'red'}}>P{formatNumber(creditAccount.total_balance)}</span></div>
            </div>
          : <span>New Credit Account</span>
        }
        </div>
        <div className='tabs-button-container'>
          {
            (creditAccount) ?
              <button
                style={{display: (creditAccount.status === 'On Process') ? 'block' : 'none'}}
                onClick={onClick}
                id='0manage-invoices-tab-button'
                className='pospro-action-btn tab-button tab-button-active'>
                Manage Invoices
              </button>
            : null
          }
          <button
            onClick={onClick}
            id='1payment-history-tab-button'
            className='pospro-action-btn tab-button'>
            Payment History
          </button>
          <button
            onClick={onClick}
            id='2soa-tab-button'
            className='pospro-action-btn tab-button'>
            Statement Of Account
          </button>
        </div>
        <hr/>
        <div className='tab-contents'>
          <ManageInvoices show={(tabContent === 0)}/>
          <PaymentHistory show={(tabContent === 1)}/>
          <SOA show={(tabContent === 2)}/>
        </div>
      </div>
      <CustomerCreditAccountInnerStyle />
    </ContentInner>
  )
}

export default React.memo(CustomerCreditAccountInner)
